import { defineComponent as A, useAttrs as $, computed as h, ref as F, watch as x, openBlock as n, createElementBlock as a, createElementVNode as b, mergeProps as E, unref as c, Fragment as v, renderList as _, normalizeClass as k, createBlock as P, createCommentVNode as d, toDisplayString as C, normalizeStyle as g, renderSlot as D, createTextVNode as L } from "vue";
import Y from "./novoui-vuejs10.js";
import { ButtonToggleSize as u, ButtonToggleVariant as j, getToggleButtonStyleClasses as q } from "./novoui-vuejs65.js";
const G = { class: "button-group-container" }, H = ["data-testid", "onClick", "disabled"], I = { key: 1 }, Q = /* @__PURE__ */ A({
  inheritAttrs: !1,
  __name: "NToggleButtons",
  props: {
    activeToggleButtonId: {},
    size: { default: u.medium },
    variant: { default: j.fill },
    content: {},
    height: {},
    contentClasses: {}
  },
  emits: [
    /**
     * Event emitted when the user clicks one of the toggle buttons
     */
    "update:toggleButtonClicked"
  ],
  setup(T, { emit: y }) {
    const { class: z, ...N } = $(), S = y, i = T, m = h(
      () => {
        var t;
        return (t = i.content) != null && t.some((s) => !!s.order) ? i.content.sort((s, e) => {
          const o = p(s.order), l = p(e.order);
          return o <= l ? -1 : 1;
        }) : i.content;
      }
    );
    function p(t) {
      return !t && t !== 0 || isNaN(t) ? 999 : t;
    }
    const V = h(() => q(i));
    function w(t, s) {
      var o;
      S("update:toggleButtonClicked", s, t);
      const e = (o = i.content) == null ? void 0 : o.find((l) => s === l.id);
      e != null && e.method ? (f(s), e.method(t, s)) : f(s);
    }
    function f(t) {
      r.value = t;
    }
    const r = F(i.activeToggleButtonId || i.content && i.content[0].id || "0");
    return x(() => i.activeToggleButtonId, (t, s) => {
      r.value = t || r.value;
    }), (t, s) => (n(), a("div", G, [
      b("div", E({
        class: ["button-group", c(z)]
      }, N), [
        (n(!0), a(v, null, _(m.value, (e) => (n(), a("button", {
          key: e.id,
          "data-testid": e.dataTestid,
          onClick: (o) => w(o, e.id),
          class: k(["button-toggle button-toggle-primary", [V.value, { "button-toggle-selected": r.value === e.id }]]),
          disabled: e.disabled
        }, [
          e.icon ? (n(), P(Y, {
            key: 0,
            icon: e.icon,
            size: i.size === c(u).large || i.size === c(u).lg && !(e.label && e.label.trim()) ? 18 : 14
          }, null, 8, ["icon", "size"])) : d("", !0),
          e.label && e.label.trim() ? (n(), a("span", I, C(e.label), 1)) : d("", !0)
        ], 10, H))), 128))
      ], 16),
      b("div", {
        class: k(["button-group-content", t.contentClasses]),
        style: g({ height: `${i.height}px`, overflowY: i.height ? "auto" : "initial" })
      }, [
        (n(!0), a(v, null, _(m.value, (e) => (n(), a("div", null, [
          e.id === r.value && !e.skipSwitchToOnClick ? D(t.$slots, `toggle_buttons_${e.id}`, { key: 0 }, () => [
            L(C(e.content), 1)
          ]) : d("", !0)
        ]))), 256))
      ], 6)
    ]));
  }
});
export {
  Q as default
};
